import React, { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import { Box, CircularProgress } from "@mui/material";
import { isValidInput } from "../../utils/validations";
import useTranslation from "../../hooks/traslation";
import MainContainer from "../../layout/MainContainer";
import PayoutList from "../../features/managePayout/PayoutList";
import { useLazyGetPayOutQuery } from "../../services/payout";
import { showError } from "../../constants/toasts";

function ManagePayout() {
  const [getPayOut] = useLazyGetPayOutQuery();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const translation = useTranslation();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState(0);
  const [rows, setRows] = useState<any[]>([]);
  const limit = 10;
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };
  const getAllPayouts = async () => {
    setLoading(true);
    try {
      const response = await getPayOut({
        page,
        limit,
        search: debouncedSearchTerm.trim(),
      }).unwrap();

      if (response?.statusCode === 200) {
        setLoading(false);
        setRows(response?.data[0]?.list || []);
        setCount(response?.data[0]?.totalCount);
      } else {
        setLoading(false);
        setRows([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };
  useEffect(() => {
    getAllPayouts();
  }, [page, debouncedSearchTerm]);
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Payout</h1>
        <div className="cards">
          <Box className="search_box" style={{ marginBottom: "20px" }}>
            <SearchBar
              placeholder={translation.user.SearchHere}
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </Box>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "2rem",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <PayoutList
                rows={rows}
                isLoading={loading}
                count={count}
                page={page}
                onPageChange={handlePageChange}
                onRefresh={getAllPayouts}
              />
              {rows.length !== 0 && (
                <div className="table_footer">
                  <div className="pagination_info">
                    <span className="total_records">Showing {rows.length} of {count} records</span>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </MainContainer>
  );
}

export default ManagePayout;
